/**
 * BannerCRC — Banner Content Rendering Contract
 * 
 * Defines the exact mapping from banner data → visual pixels.
 * Drives: img styles, overlay, swiper motion, layout.
 */
export const BannerCRC = {
  // ---- Image Rendering ----
  image: {
    aspectRatio: '16/9',
    objectFit: 'cover',
    objectPosition: 'center',
    scaleBase: 1.02,       // slight scale-up for "breathing" effect
    transformOrigin: 'center center',
    borderRadius: 'var(--radius-xl)',
    filter: 'none',
  },

  // ---- Overlay/Post-Processing ----
  overlay: {
    enabled: true,
    type: 'linear-gradient',
    gradient: '180deg, transparent 55%, rgba(0,0,0,0.5) 100%',
    zIndex: 2,
  },

  // ---- Container ----
  container: {
    margin: '0 10px 24px',
    borderRadius: 'var(--radius-xl)',
    overflow: 'hidden',
  },

  // ---- Swiper Motion ----
  swiper: {
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    spaceBetween: 12,
    speed: 300,
    autoplay: { delay: 2500, disableOnInteraction: false },
    // Motion effects
    parallax: true,
    scaleEffect: false,
    speedFactor: 1.0,
  },

  // ---- Pagination ----
  pagination: {
    enabled: true,
    position: 'bottom',
    offset: '12px',
    bulletSize: '6px',
    bulletActiveSize: '16px',
    bulletColor: 'rgba(255,255,255,0.4)',
    bulletActiveColor: '#fff',
  },
}

/**
 * Apply CRC to generate inline styles for a banner image
 */
export function applyBannerCRC(item = {}, crc = BannerCRC) {
  const { image } = crc
  return {
    style: {
      aspectRatio: image.aspectRatio,
      objectFit: image.objectFit,
      objectPosition: image.objectPosition,
      transform: `scale(${image.scaleBase})`,
      transformOrigin: image.transformOrigin,
      display: 'block',
      width: '100%',
    },
    overlayStyle: crc.overlay.enabled ? {
      position: 'absolute',
      inset: '0',
      zIndex: crc.overlay.zIndex,
      background: crc.overlay.gradient,
      pointerEvents: 'none',
    } : null,
  }
}
